// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".2bd7c5b9ed04012e802c6c29f7310f084bff32bc.chunk.js";
};